import api from './api';

/**
 * „Heute“-Laufband der Startseite (Marcel 2026-10-24): GET /api/home/ticker (öffentlich, Cache 2 min).
 * Einträge sind tagesaktuell: Turniere heute, offenes Training heute, geöffnete Spielstätten/Shops,
 * Serien-Termine, Liga-Spieltage, offene Tippspiele, PDC-Spiele heute.
 */
export type HomeTickerType =
  | 'tournament-today'
  | 'open-training'
  | 'pub-open'
  | 'shop-open'
  | 'series-event'
  | 'league-matchday'
  | 'prediction-open'
  | 'pro-matches';

export interface HomeTickerItem {
  type: HomeTickerType | string;
  id: string;
  title: string;
  subtitle?: string | null;
  time?: string | null;
  path: string;
  image?: string | null;
}

export interface HomeTickerResponse {
  dateKey: string | null;
  weekday: string | null;
  generatedAt: number;
  items: HomeTickerItem[];
}

/** Defensiv: fehlende/kaputte Antwort → leere Liste (alte Backends kennen die Route nicht) */
export function parseHomeTicker(raw: unknown): HomeTickerResponse {
  const r = (raw && typeof raw === 'object' ? raw : {}) as Partial<HomeTickerResponse>;
  const items = Array.isArray(r.items)
    ? r.items.filter((i): i is HomeTickerItem => Boolean(i && typeof i === 'object' && typeof (i as HomeTickerItem).path === 'string' && typeof (i as HomeTickerItem).title === 'string' && (i as HomeTickerItem).title.trim() !== ''))
    : [];
  return { dateKey: r.dateKey ?? null, weekday: r.weekday ?? null, generatedAt: typeof r.generatedAt === 'number' ? r.generatedAt : Date.now(), items };
}

export async function getHomeTicker(): Promise<HomeTickerResponse> {
  try {
    const res = await api.get('/api/home/ticker');
    return parseHomeTicker(res.data);
  } catch (_) {
    return { dateKey: null, weekday: null, generatedAt: Date.now(), items: [] };
  }
}

const homeTickerService = { getHomeTicker, parseHomeTicker };
export default homeTickerService;
